/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import {
  DiscountCardColorContainer,
  DiscountCardNameContainer,
  NameIconContainer,
} from "./styles";
import { StyledTypography } from "../../../pages/network_guests/styles";

export const DiscountCardName = ({ name, color }) => {
  return (
    <DiscountCardNameContainer>
      <NameIconContainer>
        <DiscountCardColorContainer
          sx={{
            background: color,
          }}
        ></DiscountCardColorContainer>
        <StyledTypography>{name}</StyledTypography>
      </NameIconContainer>
    </DiscountCardNameContainer>
  );
};
